// @ts-nocheck

import { ErrorBoundary } from 'components/generic'
import { useSelector } from 'react-redux'
import AddCarePlanModal from './AddCarePlanModal'
import AddEmarMedicationModal from './AddEmarMedicationModal'
import AddLogModal from './AddLogModal'
import AddResidentModal from './AddResidentModal'
import AddShiftModal from './AddShiftModal'
import AddTeamMemberModal from './AddTeamMemberModal'
import AddZoneModal from './AddZoneModal'
import CarePlanDocumentModal from './CarePlanDocumentModal'
import CreateRiskAssessment from './CreateRiskAssessment'
import DocumentModal from './DocumentModal'
import EditResidentZoneModal from './EditResidentZoneModal'
import EditShiftModal from './EditShiftModal'
import EditZoneModal from './EditZoneModal'
import EmarDiscontinueMedModal from './EmarDiscontinueMedModal'
import EmarMedicationQuantityModal from './EmarMedicationQuantityModal'
import EmarRoundTimingModal from './EmarRoundTimingModal'
import FamilyPortalSetupModal from './FamilyPortalSetupModal'
import HomeChangedBlockingModal from './HomeChangedBlockingModal'
import InviteFamilyModal from './InviteFamilyModal'
import OnboardEmarModal from './OnboardEmarModal'
import StockLogModal from './StockLogModal'
import SwitchHomeModal from './SwitchHomeModal'
import TaskCreateModal from './TaskCreateModal'
import TaskEditModal from './TaskEditModal'

// Each eMAR modal is keyed by its own open state (from state.modals[modalId],
// set by the shared Modal() HOC in ./index.tsx) so a crash in one doesn't
// permanently disable the others: once an ErrorBoundary catches an error it
// stays in that state until unmounted, so changing the key on close/reopen
// forces a fresh instance to get a clean render next time.
const MountedModals = ({ router }) => {
  const isAddEmarMedicationOpen = useSelector((state) =>
    Boolean(state.modals?.addEmarMedication)
  )
  const isOnboardingEmarOpen = useSelector((state) =>
    Boolean(state.modals?.onboardingEmar)
  )
  const isEmarRoundTimingOpen = useSelector((state) =>
    Boolean(state.modals?.addEmarRoundTimingModal)
  )
  const isDiscontinueMedOpen = useSelector((state) =>
    Boolean(state.modals?.discontinueMed)
  )
  const isMedicationQuantityOpen = useSelector((state) =>
    Boolean(state.modals?.medicationQuantity)
  )
  const isAddStockLogOpen = useSelector((state) =>
    Boolean(state.modals?.addStockLog)
  )

  return (
    <div>
      <AddCarePlanModal router={router} />
      <AddResidentModal router={router} />
      <SwitchHomeModal router={router} />
      <HomeChangedBlockingModal />
      <AddTeamMemberModal router={router} />
      <AddShiftModal />
      <AddZoneModal />
      <CreateRiskAssessment router={router} />
      <CarePlanDocumentModal />
      <DocumentModal />
      <EditResidentZoneModal />
      <EditShiftModal />
      <EditZoneModal />
      <FamilyPortalSetupModal />
      <TaskEditModal />
      <TaskCreateModal />
      <AddLogModal />
      <InviteFamilyModal />
      <ErrorBoundary
        area="emar"
        silent
        key={`addEmarMedication-${isAddEmarMedicationOpen}`}
      >
        <AddEmarMedicationModal router={router} />
      </ErrorBoundary>
      <ErrorBoundary
        area="emar"
        silent
        key={`onboardingEmar-${isOnboardingEmarOpen}`}
      >
        <OnboardEmarModal router={router} />
      </ErrorBoundary>
      <ErrorBoundary
        area="emar"
        silent
        key={`addEmarRoundTimingModal-${isEmarRoundTimingOpen}`}
      >
        <EmarRoundTimingModal />
      </ErrorBoundary>
      <ErrorBoundary
        area="emar"
        silent
        key={`discontinueMed-${isDiscontinueMedOpen}`}
      >
        <EmarDiscontinueMedModal />
      </ErrorBoundary>
      <ErrorBoundary
        area="emar"
        silent
        key={`medicationQuantity-${isMedicationQuantityOpen}`}
      >
        <EmarMedicationQuantityModal />
      </ErrorBoundary>
      <ErrorBoundary
        area="emar"
        silent
        key={`addStockLog-${isAddStockLogOpen}`}
      >
        <StockLogModal />
      </ErrorBoundary>
    </div>
  )
}

export default MountedModals
